export const X_SKIP_ALERT = 'X-Skip-Alert';
export const X_EXCLUDE_BASE_URL = 'X-Exclude-Base-URL';
export const X_THIRD_PARTY_REQUEST = 'X-Third-Party-Request';
